import React, { useEffect, useState } from "react";
import { DotLoaderOverlay } from 'react-spinner-overlay';

import causalService from "../services/causal.service";

/** MUI */
import {
    Box,
    Button,
    Container,
    Typography
} from "@mui/material";
import MUIDataTable from 'mui-datatables';

const CausalGerencia = () => {
    const [casusales, setCasusales] = useState([]);
    const [loading, setLoading] = useState(false);
    const refreshTime = 3600000;

    useEffect(() => {
        retreiveCausales();
        const comInterval = setInterval(retreiveCausales, refreshTime);
        //retreiveCausales();
        return () => clearInterval(comInterval);
    }, []);

    async function retreiveCausales() {
        setLoading(true);
        try {
            const currentURL = window.location.host;
            const protocol = window.location.protocol;
            const baseurl = protocol + "//" + currentURL;
            let causals = await causalService.getGenGer();
            console.log("Causales", causals);
            var csls = causals.data;
            csls.sort(function (a, b) {
                return b.id - a.id;
            });
            var arr_temp = [];
            for (var i in csls) {
                console.log(csls[i]);
                var persona = csls[i].persona;
                let temp = {
                    nombre: csls[i].perNombre1 + " " + csls[i].perApPaterno,
                    rut: csls[i].Rut,
                    link: `${baseurl}/finiquitogergen/${csls[i].id}`,
                    fecha_ingreso: csls[i].fecha_ingreso,
                    unidad_negocio: csls[i].ctoDescripcion,
                }
                arr_temp.push(temp);

            }
            /*
            for (var i in csls) {
                //console.log("TAM APROBADO", csls[i].aprobado.length);
                if (csls[i].aprobado.length !== 0) {
                    //console.log("Agrupar los aprobados "+i);
                    var aprobados = csls[i].aprobado;
                    var admin = aprobados.find(v => v.tipo === "ADMINISTRADOR");
                    var rrhh = aprobados.find(v => v.tipo === "RRHH");
                    var finanzas = aprobados.find(v => v.tipo === "FINANZAS");
                    if (admin) {
                        //En poder de RRHH
                        //console.log("Administrador", admin);
                    }
                    if (rrhh && !finanzas) {
                        //En poder de FINANZAS (LUIS BELMAR)
                        console.log("Aprobados", csls[i]);
                        var persona = csls[i].persona;
                        let temp = {
                            nombre: persona.perNombre1 + " " + persona.perApPaterno,
                            rut: persona.Rut,
                            link: `${baseurl}/finiquito3/${csls[i].id}`,
                        }
                        arr_temp.push(temp);
                    }
                    if (finanzas) {
                        //En poder de FINANZAS (Carla DIAZ)
                    }
                } else {
                    console.log("Todavia no se ha hecho nada " + i);
                }
            } */
            //setCasusales(csls);
            setCasusales(arr_temp);
            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    }

    const columns = [
        { name: "rut", label: "Rut" },
        { name: "nombre", label: "Nombre" },
        { name: "unidad_negocio", label: "Unidad de Negocio" },
        { name: "fecha_ingreso", label: "Fecha Desvinculación" },
        {
            name: "link", label: "Link", options: {
                customBodyRender: (value, tableMeta, updateValue) => (
                    <Button href={value} variant='outlined' target="_blank">VER FINIQUITO</Button>
                )
            }
        },
    ];

    return (
        <Container>
            {loading ? (
                <DotLoaderOverlay size={28} message="Cargando..." color="#4F8BFA" />
            ) : ""}
            <Typography variant="h3">
                CAUSALES
            </Typography>
            <Box
                margin={3}
                alignItems="center"
                justifyContent="center"
                display="flex"
            >
                <MUIDataTable
                    columns={columns}
                    data={casusales}
                />
            </Box>
        </Container>
    )

}

export default CausalGerencia;